import { render, staticRenderFns } from "./globalAlerts.vue?vue&type=template&id=aa1c24f2"
import script from "./globalAlerts.vue?vue&type=script&lang=ts"
export * from "./globalAlerts.vue?vue&type=script&lang=ts"
import style0 from "./globalAlerts.vue?vue&type=style&index=0&id=aa1c24f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports